<template>
  <span>{{ value }}</span>
</template>

<script lang="ts" setup>
  export interface Props {
    value: string;
  }

  defineProps<Props>();
</script>
